import {Component, EventEmitter, OnInit, Output} from '@angular/core';

import {SurveyService} from './../../surveys.service';
import {SurveyCreatePDModel} from './../../../../models/survey/survey.model';
import {AuthTokenService} from '../../../../shared/services/auth-token.service';


@Component({
  selector: 'app-intro-tab',
  templateUrl: './intro-tab.component.html',
  styleUrls: ['./intro-tab.component.less']
})
export class IntroTabComponent implements OnInit {

  info: boolean;
  @Output() surveyCreatePDModelChange = new EventEmitter<SurveyCreatePDModel>();
  isAdmin = AuthTokenService.isAdmin();

  constructor(public surveyService: SurveyService) {
  }

  ngOnInit() {
    this.info = false;
  }

  save() {
    this.surveyCreatePDModelChange.emit(this.surveyService.surveyCreatePDModel);
  }

  showInfo() {
    this.info = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/intro-tab/intro-tab.component.ts